// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"6b85cc63","263":"6b85cc63","622":"a6d755fa","737":"6b85cc63"}[chunkId] + ".chunk.css";
};